import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ApiInstructuionRoutingModule } from './api-instruction-routing.module';
import { ApiInstructionComponent } from './pages/api-instruction/api-instruction.component';
import { GenerateApiPasswordComponent } from './pages/generate-api-password/generate-api-password.component';

@NgModule({
  declarations: [
    ApiInstructionComponent,
    GenerateApiPasswordComponent
  ],
  imports: [
    CommonModule,
    ApiInstructuionRoutingModule,
    SharedModule,
    FlexLayoutModule,
  ],
})
export class ApiInstructionModule {}
